import { createReducer, on } from '@ngrx/store';
import { componentPermissionActions } from './component-permission.actions';
import { IHiddenElementAssignment } from '../../shared/service/role-based-element-hide.model';
import { ELoadStatus } from '../../../constants.model';

export interface IComponentPermissionState {
  assignments: IHiddenElementAssignment[] | null;
  loadStatus: ELoadStatus;
}

export const initialState: IComponentPermissionState = {
  assignments: null,
  loadStatus: ELoadStatus.Initial,
};

export const componentPermissionReducer = createReducer(
  initialState,
  on(componentPermissionActions.loadCurrentUserAssignments, (state) => ({
    ...state,
    loadStatus: ELoadStatus.Loading,
  })),
  on(componentPermissionActions.setCurrentUserAssignmentsToStore, (state, action) => ({
    ...state,
    assignments: action.assignments,
    loadStatus: ELoadStatus.Success,
  })),
);
